<template>
  <v-card class="mx-auto" :disabled="loading" :loading="loading">
    <v-card-title> ตั้งค่าหน่วยกิตวิชาวิทยานิพนธ์ </v-card-title>
    <v-card-text>
      <StudentInfo />
    </v-card-text>
    <v-card-text class="px-1 px-md-3 px-xl-6">
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(level, i) in levels" :key="i">
          <h3>
            {{ level.LEVEL_NAME_EN }}
          </h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="level_tab" touchless>
        <v-tab-item v-for="(level, i) in levels" :key="i">
          <v-card flat>
            <v-card-text class="px-1 px-md-3 px-xl-6">
              <v-form v-model="form_validate_status" ref="form">
                <v-row>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="selected_faculty_id"
                      :items="faculties"
                      :item-value="(item) => item.faculty_id"
                      :item-text="(item) => item.faculty_name_th"
                      outlined
                      dense
                      label="คณะ"
                      hide-details
                      :rules="required"
                      @change="update_faculty()"
                    />
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-autocomplete
                      v-model="selected_curriculum_id"
                      :items="filter_curriculums"
                      :item-value="(item) => item.curriculum_id"
                      :item-text="
                        (item) =>
                          'currID: ' +
                          item.curriculum_id +
                          ' ' +
                          item.curriculum_name_th +
                          ' (' +
                          item.year +
                          ')'
                      "
                      outlined
                      dense
                      label="หลักสูตร"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                      clearable
                      placeholder="แนะนำให้พิมพ์ชื่อหลักสูตรแบบสั้น เพื่อกรองข้อมูล (และกรณีมีชื่อซ้ำ)"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete
                      v-model="selected_year"
                      :items="years"
                      outlined
                      dense
                      label="ปีการศึกษาที่รับเข้า"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete
                      v-model="selected_semester"
                      :items="semesters"
                      outlined
                      dense
                      label="เทอมที่รับเข้า"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="selected_study_plan_id"
                      :items="filter_study_plans"
                      :item-value="(item) => item.STUDY_PLAN_ID"
                      :item-text="(item) => item.study_plan_name"
                      outlined
                      dense
                      label="แผนการศึกษา"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <spam v-if="!form_validate_status"
                      >เลือกเงื่อนไขให้ครบหากต้องการ "เพิ่มข้อมูล" ใหม่</spam
                    >
                    <v-btn
                      color="success"
                      @click="
                        $refs.addEditDialog.open_add_modal(
                          selected_level,
                          selected_faculty_id,
                          selected_curriculum_id,
                          selected_year,
                          selected_semester,
                          selected_study_plan_id,
                          selected_prog_id,
                          selected_sub_prog_id,
                          name_faculty,
                          name_curriculum,
                          name_study_plan
                        )
                      "
                      v-if="form_validate_status"
                    >
                      <v-icon>mdi-plus</v-icon>เพิ่มข้อมูล
                    </v-btn></v-col
                  >
                </v-row>
              </v-form>

              <v-simple-table
                min-height="300px"
                class="mt-3 text-no-wrap text-center"
              >
                <thead class="blue-grey darken-1">
                  <tr>
                    <th
                      class="white--text text-center font-weight-regular"
                      rowspan="2"
                    >
                      แก้ไข/ลบ
                    </th>
                    <th
                      class="white--text text-center font-weight-regular"
                      rowspan="2"
                    >
                      #
                    </th>
                    <th
                      class="white--text text-center font-weight-regular"
                      rowspan="2"
                    >
                      ปี/เทอม ที่รับเข้า
                    </th>
                    <th
                      class="white--text text-center font-weight-regular"
                      rowspan="2"
                    >
                      แผนการเรียน
                    </th>
                    <th
                      class="white--text text-center font-weight-regular"
                      rowspan="2"
                    >
                      รหัสวิชา
                    </th>
                    <th
                      class="white--text text-center font-weight-regular"
                      rowspan="2"
                    >
                      หน่วยกิตทั้งหมด
                    </th>
                    <th
                      class="white--text text-center font-weight-regular"
                      colspan="10"
                    >
                      เทอม
                    </th>
                    <th
                      class="white--text text-center font-weight-regular"
                      rowspan="2"
                    >
                      วันที่บันทึก [ผู้บันทึก]
                    </th>
                  </tr>
                  <tr>
                    <th
                      v-for="term in 10"
                      :key="term"
                      class="white--text text-center font-weight-regular"
                    >
                      {{ term }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="data.length === 0">
                    <td colspan="17">
                      <p class="text-center text-secondary mb-0">no result</p>
                    </td>
                  </tr>
                  <tr v-for="(item, index) in data" :key="index">
                    <td>
                      <v-btn
                        small
                        color="warning"
                        v-on:click="
                          $refs.addEditDialog.open_edit_modal(
                            selected_level,
                            selected_faculty_id,
                            selected_curriculum_id,
                            selected_year,
                            selected_semester,
                            selected_study_plan_id,
                            item.prog_id,
                            item.sub_prog_id,
                            name_faculty,
                            name_curriculum,
                            item
                          )
                        "
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        class="ml-2"
                        small
                        color="error"
                        @click="
                          $refs.deleteDialog.open_delete_modal(
                            selected_level,
                            selected_faculty_id,
                            selected_curriculum_id,
                            selected_year,
                            selected_semester,
                            selected_study_plan_id,
                            name_faculty,
                            name_curriculum,
                            item
                          )
                        "
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.admis_term }}/{{ item.admis_year }}</td>
                    <td>
                      {{ item.study_plan_name }}
                    </td>
                    <td style="text-align: left">
                      {{ item.subject_id }}
                      -<span
                        :style="{
                          color:
                            item.subject_type === 'T'
                              ? 'blue'
                              : item.subject_type === 'S'
                              ? 'yellow'
                              : 'red',
                          fontWeight: 'bold',
                        }"
                      >
                        {{ item.subject_type }} </span
                      >-
                      {{ item.subject_name }}
                    </td>
                    <td>{{ item.credit_all }}</td>
                    <td v-for="term in 10" :key="term">
                      {{ item[`term${term}`] }}
                    </td>
                    <td>{{ dt(item.datetime) }} [{{ item.operator }}]</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <ConfigGraduateSeparateThesisCreditAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
      :fetch_data="fetch_data"
    />

    <ConfigGraduateSeparateThesisCreditDeleteDialog
      ref="deleteDialog"
      :toggle_loading="toggle_loading"
      :fetch_data="fetch_data"
    />
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import ConfigGraduateSeparateThesisCreditAddEditDialog from "./components/ConfigGraduateSeparateThesisCreditAddEditDialog";
import ConfigGraduateSeparateThesisCreditDeleteDialog from "./components/ConfigGraduateSeparateThesisCreditDeleteDialog";
import { dateTimeFromDBTranslatorFull as dt } from "@/helper/translator";
import ConfigProvider from "@/services/config.provider";
import GenericProvider from "@/services/generic.provider";
import RefProvider from "@/services/ref.provider";
import StudentInfo from "@/views/user/StudentInfo.vue";

const semesters = ["1", "2"];
const configService = new ConfigProvider();
const genericService = new GenericProvider();
const refService = new RefProvider();

export default {
  name: "ConfigGraduateSeparateThesisCredit",
  data: () => ({
    loading: false,
    level_tab: 2,

    levels: [
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "ปริญญาโท",
        LEVEL_NAME_TH: "ปริญญาโท",
      },
      {
        LEVEL_ID: "3",
        LEVEL_NAME_EN: "ปริญญาเอก",
      },
    ],
    faculties: [],
    curriculums: [],
    study_plans: [],
    filter_study_plans: [],

    years: [],
    semesters: semesters,

    selected_faculty_id: null,
    selected_curriculum_id: null,
    selected_year: null,
    selected_semester: "1",
    selected_study_plan_id: null, //map ข้อมูลย่อยไปเป็น selected_prog_id และ selected_sub_prog_id

    required: [(v) => !!v || "Required"],

    form_validate_status: false,

    data: [],
  }),
  components: {
    ConfigGraduateSeparateThesisCreditAddEditDialog,
    ConfigGraduateSeparateThesisCreditDeleteDialog,
    StudentInfo,
  },

  methods: {
    dt,
    async get_all_faculties() {
      const response = await genericService
        .getRegistrarFaculty()
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });

      if (response) this.faculties = response;
    },

    async get_all_curriculum(val) {
      const response = await genericService
        .getRegistrarCurriculum(parseInt(val))
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });

      if (response) this.curriculums = response;
    },

    get_years() {
      const maxYear = parseInt(dayjs().format("BBBB")) + 2;
      for (let year = 2550; year <= maxYear; year++) this.years.push(year);
      this.years.sort().reverse();
    },

    async get_all_study_plan() {
      const response = await refService.getStudyPlan().catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
      });

      if (response) {
        let default_study_plan = {
          STUDY_PLAN_ID: "99",
          study_plan_name: "สำหรับทุกแผนการเรียน",
          STUDY_PLAN_NAME_TH_BELOW_2566: "สำหรับทุกแผนการเรียน",
          STUDY_PLAN_NAME_TH: "สำหรับทุกแผนการเรียน",
        };
        this.study_plans = response;
        this.filter_study_plans = this.study_plans.filter(
          (item) => item.LEVEL_ID === this.selected_level
        );
        this.filter_study_plans.map((item) => {
          item.study_plan_name = item.STUDY_PLAN_NAME_TH;
        });
        this.filter_study_plans.unshift(default_study_plan);
      }
    },

    update_faculty() {
      this.data = [];
      this.selected_curriculum_id = null;
      this.curriculums = this.curriculums.filter(
        (item) => item.LEVEL_ID === this.level_id_fake
      );
    },

    update_student_plan_by_year() {
      this.filter_study_plans.map((item) => {
        item.study_plan_name =
          this.selected_year <= 2566
            ? item.STUDY_PLAN_NAME_TH_BELOW_2566
            : item.STUDY_PLAN_NAME_TH;
      });
    },

    async fetch_data() {
      this.loading = true;
      this.data = [];
      if (
        this.selected_curriculum_id &&
        this.selected_year &&
        this.selected_semester
      ) {
        let response = await configService
          .getGraduateSeparateThesisCredit({
            curr_id: this.selected_curriculum_id,
            year: this.selected_year,
            semester: this.selected_semester,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.loading = false;
          });

        if (response) {
          if (this.selected_study_plan_id) {
            response = response.filter(
              (item) =>
                item.prog_id === this.selected_prog_id &&
                item.sub_prog_id === this.selected_sub_prog_id
            );
          }
          this.data = response.map((item_data) => {
            if (item_data["prog_id"] == "99") {
              item_data.study_plan_name = "สำหรับทุกแผนการเรียน";
            } else {
              let ref_data = this.study_plans.find(
                (item) =>
                  item["REGISTRAR_PROGRAM_ID"] == item_data["prog_id"] &&
                  item["REGISTRAR_SUB_PROGRAM_ID"] == item_data["sub_prog_id"]
              );
              item_data.study_plan_name =
                ref_data && this.selected_year <= 2566
                  ? ref_data.STUDY_PLAN_NAME_TH_BELOW_2566
                  : ref_data
                  ? ref_data.STUDY_PLAN_NAME_TH
                  : "Unknown Study Plan";
            }

            return item_data;
          });
        }
      }

      this.loading = false;
    },

    toggle_loading(status) {
      this.loading = status;
    },
  },

  computed: {
    filter_curriculums() {
      let data = [];
      if (this.selected_faculty_id) {
        data = this.curriculums.filter(
          (item) => item.faculty_id === this.selected_faculty_id
        );
      }
      return data;
    },
    selected_level() {
      return this.levels[this.level_tab].LEVEL_ID;
    },
    name_faculty() {
      return this.faculties.find(
        (item) => item.faculty_id === this.selected_faculty_id
      )?.faculty_name_th;
    },
    name_curriculum() {
      return this.curriculums.find(
        (item) => item.curriculum_id === this.selected_curriculum_id
      )?.curriculum_name_th;
    },
    name_study_plan() {
      if (this.selected_study_plan_id === "99") {
        return "สำหรับทุกแผนการเรียน";
      } else {
        if (this.selected_year <= 2566) {
          return this.study_plans.find(
            (item) => item.STUDY_PLAN_ID === this.selected_study_plan_id
          )?.STUDY_PLAN_NAME_TH_BELOW_2566;
        } else {
          return this.study_plans.find(
            (item) => item.STUDY_PLAN_ID === this.selected_study_plan_id
          )?.STUDY_PLAN_NAME_TH;
        }
      }
    },
    selected_prog_id() {
      if (this.selected_study_plan_id === "99") {
        return "99";
      } else {
        return this.study_plans.find(
          (item) => item.STUDY_PLAN_ID === this.selected_study_plan_id
        )?.REGISTRAR_PROGRAM_ID;
      }
    },
    selected_sub_prog_id() {
      if (this.selected_study_plan_id === "99") {
        return "0";
      } else {
        return this.study_plans.find(
          (item) => item.STUDY_PLAN_ID === this.selected_study_plan_id
        )?.REGISTRAR_SUB_PROGRAM_ID;
      }
    },
  },

  watch: {
    level_tab(newVal) {
      this.data = [];
      this.selected_level = this.levels[newVal].LEVEL_ID;
      this.get_all_curriculum(this.selected_level);
      this.filter_study_plans = this.study_plans.filter(
        (item) => item.LEVEL_ID == this.selected_level
      );
      let default_study_plan = {
        STUDY_PLAN_ID: "99",
        study_plan_name: "สำหรับทุกแผนการเรียน",
        STUDY_PLAN_NAME_TH_BELOW_2566: "สำหรับทุกแผนการเรียน",
        STUDY_PLAN_NAME_TH: "สำหรับทุกแผนการเรียน",
      };
      this.filter_study_plans.unshift(default_study_plan);
      this.update_student_plan_by_year();
    },
    selected_year() {
      this.update_student_plan_by_year();
    },
  },

  created() {
    this.get_all_faculties();
    this.get_all_curriculum(2);
    this.get_years();
    this.get_all_study_plan();
  },
};
</script>

<style>
th {
  letter-spacing: 1px;
}
.last-cell {
  border-right-width: 1px;
}
</style>
